import { createAsyncThunk } from '@reduxjs/toolkit'
import { AxiosError } from 'axios'
import { Moment } from 'moment'

import clientSDK from '../../../App/ClientSDK'
import {
  axiosErrorHandler,
  IThunkReject,
} from '../../../App/Util/axiosErrorHandler'
import { updateAppointmentActivityTransformer } from '../transformer/updateAppointmentActivityTransformer'

export interface IUpdateAppointmentData {
  id: number
  personId?: number
  startsAt: Moment
  endsAt: Moment
  updateRepeatAppointments?: false
  isLocked: boolean | null
}

export interface IUpdateAppointmentActivity {
  data: IUpdateAppointmentData
  appointmentUuid: string
  isLockedUpdate?: boolean
}

export interface IUpdateAppointmentActivityReturn {
  appointmentUuid: string
}

export const updateAppointmentActivity = createAsyncThunk<
  IUpdateAppointmentActivityReturn,
  IUpdateAppointmentActivity,
  IThunkReject<any>
>('update/appointment/activity/post', async (payload, { rejectWithValue }) => {
  const { appointmentUuid } = payload
  const { id, isLocked } = payload.data
  let apiData: null | IUpdateAppointmentActivityReturn = null

  try {
    const apiObject =
      typeof payload.isLockedUpdate !== 'undefined' &&
      payload.isLockedUpdate &&
      isLocked !== null
        ? { is_locked: isLocked }
        : updateAppointmentActivityTransformer(payload.data)

    const promise = clientSDK.instance().post(`blocks/${id}`, apiObject)

    const result = await promise

    apiData = { appointmentUuid }
  } catch (error) {
    const handleAxiosError = axiosErrorHandler<any>(res => res)
    const generatedError = handleAxiosError(error as Error | AxiosError)
    return rejectWithValue(generatedError)
  }

  return apiData
})
